import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
  } from '@angular/core';

import {Speaker} from '../models/speaker';
import {SpeakerService} from '../speaker.service';

declare let d3;

const SCATTER = "scatterChart", SCATTERREGRESSION = "scatterPlusLineChart";

@Component({
  selector: 'age',
  template: `
  <button type="button" class="btn btn-primary" (click)="speakerSrv.changeView('RES', $event)"><i class="fa fa-chevron-left" aria-hidden="true"></i>
Back</button>
  <span style="position: absolute; right: 11.5em; top: 2.5em; display: inline-block;">
	  Line&#160;
	  <input type="checkbox" (change)="toggleReg();">
  </span>
  <nvd3 [options]='options' [data]='data' id="Scatter"></nvd3>`,
  styleUrls: ['./age.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AgeChartComponent implements OnInit {
  options;
  data;
  plotData;
  stats;

  constructor(private speakerSrv: SpeakerService) { }
  
  toggleReg() {
	  if (this.options.chart.type == SCATTER) {
		  this.options.chart.type = SCATTERREGRESSION;
	  } else {
		  this.options.chart.type = SCATTER;
	  }
	  this.update(this.stats);
  }

  ngOnInit() {
    this.speakerSrv.statsChange.subscribe(stats => { 
    	this.stats = stats;
    	this.update(stats);
    });
    this.options = {
      chart: {
        type: SCATTER,
        height: 450,
        color: ['rgb(125,222,238)', 'rgb(247,126,151)'],
        scatter: {
          onlyCircles: false
        },
        showDistX: true,
        showDistY: true,
        duration: 350,
        xAxis: {
          axisLabel: 'Age',
          tickFormat: function(d){
            return d3.format('.0f')(d);
          }
        },
        forceX: [0],
        yAxis: {
          axisLabel: 'Relative Frequency Per 10,000',
          tickFormat: function(d) {
	        	if (d != 0) {
	    	  		let i = 2;
	  	 		while(Number(d3.format(',.0' + i + 'f')(d).replace(",", "")) == 0) {
	  	  			i++;
	  	  		}
	  	  		return d3.format(',.0' + i + 'f')(d);
	    	  	}
	    	  	return d3.format(',.0f')(d);
          }
        },
        tooltipContent: function(d) {
        	return d.name;
        },
        callback: undefined,
        noData: "Awaiting data..."
      }
    };
    let self = this;
    this.options.chart.callback = function(chart) {
    	if (self.options.chart.type == SCATTER) {
	    	chart.scatter.dispatch.on("elementClick", function(ev) {
	    		self.speakerSrv.concordanceAgeFilter.next(ev);
	    		self.speakerSrv.changeView('Concordance', ev);
	    	});
    	} else {
    		chart.scatter.dispatch.on("elementClick", function(ev) {
	    		self.speakerSrv.concordanceAgeFilter.next(ev);
	    		self.speakerSrv.changeView('Concordance', ev);
	    	});
    	}
    }
  }


  update(stats){
    let datasets = { labels: ['1994', '2014']};
    let values1994 = [];
    let values2014 = [];

 //     console.log(stats);

      if(Object.keys(stats).length > 0){
    
      //FOR EACH DATA SET
        for (let i = datasets.labels.length - 1; i >= 0; i--) {
          
          //DATA SET ITERATOR
          let l = datasets.labels[i];
    
          //DATA OBJECT KEY
          const objKeys = Object.keys(stats[l])
    
          //FOR EACH ENTRY
          for (let j = objKeys.length - 1; j >= 0; j--) {
    
            //ENTRY OBJECT
            let g = stats[l][objKeys[j]];

            if(i ==0){
              //1994
              //CREATE VALUES STRING
                values1994.push({
                x: Number(g['age'])
                , y: Number(g['relative'])
                , name: g['name new']
                , shape: 'circle'
               });
              
    
            }else if(i == 1){
    
             values2014.push({
                x: Number(g['age'])
                , y: Number(g['relative'])
             	, name: g['name new']
                , shape: 'triangle'
               });
          }
        }
            
      }      
     } else{
        console.log("ERROR: ARRAY EMPTY");
      }

 //   console.log("1994:" + JSON.stringify(values1994));
 //   console.log("2014:" + JSON.stringify(values2014));

    this.data = generateDataScatter(values1994, values2014);

  }

}
function generateDataScatter(values1994, values2014) {
  var data = [];
  
  let regression1994 = calculateRegression(values1994);
  let regression2014 = calculateRegression(values2014);

  for (var i = 0; i <=1 ; i++) {
    if(i==0){
      data.push({
        key: '1994',
        values: values1994,
        slope: regression1994.slope,
        intercept: regression1994.intercept
      });
    }else{
      data.push({
        key: '2014',
        values: values2014,
        slope: regression2014.slope,
        intercept: regression2014.intercept
      });
    }
  }
  return data;
}

function calculateRegression(data) {
	let n = data.length;
	
	//Let a equal n times the summation of all x-values multiplied by their corresponding y-values, like so
	let tmpTotal = 0;
	for (let d of data) {
		tmpTotal += d.x * d.y;
	}
	let a = n * tmpTotal;
	
	//Let b equal the sum of all x-values times the sum of all y-values, like so:
	let tmpTotalx = 0;
	let tmpTotaly = 0;
	for (let d of data) {
		tmpTotalx += d.x;
		tmpTotaly += d.y;
	}
	let b = tmpTotalx * tmpTotaly;
	
	//Let c equal n times the sum of all squared x-values, like so:
	tmpTotalx = 0;
	tmpTotaly = 0;
	
	for (let d of data) {
		tmpTotalx += Math.pow(d.x, 2);
		tmpTotaly += d.x;
	}
	let c = n * tmpTotalx;
	let d = Math.pow(tmpTotaly, 2);
	
	let slope = (a - b) / (c - d);
	
	tmpTotaly = 0;
	tmpTotalx = 0;
	for (let d of data) {
		tmpTotalx += d.x;
		tmpTotaly += d.y;
	}
	
	let e = tmpTotaly;
	let f = slope * tmpTotalx;
	let intercept = (e - f) / n;
	return {
		slope: slope,
		intercept: intercept
	};
}



// WEBPACK FOOTER //
// /home/ingvars/BNC-Lab/front/src/app/AgeChart/age.component.ts